class PageConfig {
  home = '/'
  cart = '/cart'
  products = '/products'
  productCategory = '/products/:category/:subCategory?'
  productDetails = '/product/:id'
  profile = '/profile/:slug'
  orders = '/profile/orders'
  auth = '/auth'
  notFound = '/not-found'
}

export const pageConfig = new PageConfig()
